/**
 * Creates a debounced version of the provided function.
 * @param {Function} func - The function to be debounced.
 * @param {number} [wait=200] - The delay (in milliseconds) before invoking the debounced function.
 * @returns {Function|Object} A debounced version of the provided function. If `func` is called, it returns an object containing a `cancel` function to cancel the debounce.
 */
export default function debounce(func, wait = 200) {
  let timeout;

  /**
   * Function that represents the debounced version of the provided function.
   * @param {...any} args - Arguments to be passed to the debounced function.
   */
  function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  /**
   * Cancels the debounce and prevents the debounced function from being invoked.
   */
  executedFunction.cancel = function () {
    clearTimeout(timeout);
  };

  return executedFunction;
}
